import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { CONTROL, MOTION, PRES } from '../chrome';
import { focusVisibleSx, reducedMotionSx } from './focus';

export type ThumbnailState = 'default' | 'selected' | 'hidden';

interface ThumbnailFrameProps {
  children: React.ReactNode;
  selected?: boolean;
  hidden?: boolean;
  dimmed?: boolean;
  ratio?: string;
  onClick?: (event: React.MouseEvent) => void;
  onDoubleClick?: (event: React.MouseEvent) => void;
  onContextMenu?: (event: React.MouseEvent) => void;
  sx?: SxProps<Theme>;
}

const ThumbnailFrame: React.FC<ThumbnailFrameProps> = ({
  children,
  selected = false,
  hidden = false,
  dimmed = false,
  ratio = '16 / 9',
  onClick,
  onDoubleClick,
  onContextMenu,
  sx,
}) => {
  const interactive = Boolean(onClick || onDoubleClick);
  return (
    <Box
      component={interactive ? 'button' : 'div'}
      type={interactive ? 'button' : undefined}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onContextMenu={onContextMenu}
      sx={{
        position: 'relative',
        display: 'block',
        width: '100%',
        p: 0,
        m: 0,
        aspectRatio: ratio,
        overflow: 'hidden',
        borderRadius: `${CONTROL.radius}px`,
        border: selected ? `2px solid ${PRES.interactive}` : `1px solid ${PRES.borderSubtle}`,
        boxShadow: selected ? `0 0 0 1px ${PRES.surface}, 0 0 0 3px ${PRES.interactive}` : 'none',
        bgcolor: PRES.surfaceSunken,
        cursor: interactive ? 'pointer' : 'default',
        opacity: hidden || dimmed ? 0.48 : 1,
        transition: `border-color ${MOTION.hover}, box-shadow ${MOTION.hover}, opacity ${MOTION.hover}`,
        font: 'inherit',
        color: 'inherit',
        textAlign: 'left',
        ...focusVisibleSx,
        ...reducedMotionSx,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default ThumbnailFrame;
